var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.page,
    {
      tag: "component",
      attrs: {
        appBarTitle: _vm.appBarTitle,
        appearanceOverrides: _vm.appearanceOverrides,
        loading: _vm.loading,
        primary: false,
        route: _vm.route,
        title: _vm.appBarTitle,
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function () {
            return [
              _vm.deviceId
                ? _c("DeviceConnectionStatus", {
                    attrs: { deviceId: _vm.deviceId, color: "white" },
                  })
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        {
          key: "storageNotif",
          fn: function () {
            return [
              _vm.page === "AppBarPage"
                ? _c(
                    "div",
                    [
                      _c("StorageNotification", {
                        attrs: { showBanner: _vm.showStorageNotification },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }